import React, { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import { useCountries } from "use-react-countries";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";
import { toast } from "react-toastify";
import { decrypt } from "../utils/CryptData";
// import { Field, Label, Switch } from "@headlessui/react";

function Contact() {
  const { countries } = useCountries();
  const [country, setCountry] = useState(110);
  const { name, flags, countryCallingCode } = countries[country];
  const [formData, setFormData] = useState({ email: "", nom_prenom: "", message: "" });



  if ((localStorage.getItem("dus"))) {
    const dataUser = JSON.parse(decrypt(localStorage.getItem("dus")))
    const fullName = dataUser.user[0].first_name + ' ' + dataUser.user[0].last_name
    formData.email = dataUser.user[0].email
    formData.nom_prenom = fullName
    formData.contact = dataUser.user[0].contact

  }
  const form = useRef();
  const isValidate = () => {
    let isProceed = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formData.nom_prenom.length === 0) {
      isProceed = false;
      toast.error("Veuillez entrer votre nom et prénom(s)");
    } else if (formData.email.length === 0) {
      isProceed = false;
      toast.error("Veuillez entrer votre adresse e-mail");
    } else if (!emailRegex.test(formData.email)) {
      isProceed = false;
      toast.error("Veuillez entrer une adresse e-mail valide");
    } else if (formData.message.length < 10) {
      isProceed = false;
      toast.error("Veuillez entrer un message d'au moins 10 caractères");
    }
    return isProceed;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (isValidate()) {
      emailjs
        .sendForm(process.env.REACT_APP_MAILJS_SERVICE_ID, process.env.REACT_APP_MAILJS_TEMPLATE_ID, form.current, {
          publicKey: process.env.REACT_APP_MAILJS_PUBLIC_KEY,

        })
        .then(
          () => {
            toast.success("✓ Nous avons bien reçu votre message. Merci de nous avoir contactés!");
            setFormData({ email: "", nom_prenom: "", message: "" });

          },
          (error) => {
            toast.error("Une erreur s'est produite. Veuillez réessayer.");
          },
        );
    }


  };

  return (
    <div data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-offset="200" className=" px-6 py-10 sm:py-16 lg:px-8">

      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Nous Contactez
        </h2>

      </div>
      <form
        ref={form} onSubmit={sendEmail}

        className="mx-auto mt-10 max-w-xl sm:mt-10 bg-white p-8"
      >
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <label
              htmlFor="first_name"
              className="block text-sm font-semibold leading-6 text-gray-900"
            >
              Nom et prénom(s)
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="first_name"
                id="first_name"
                placeholder="Ex: Jean Martin"
                autoComplete="given-name"
                value={formData.nom_prenom}
                onChange={(e) =>
                  setFormData({ ...formData, nom_prenom: e.target.value })
                }
                className="file-input file-input-bordered w-full px-2 "
              />
            </div>
          </div>


          <div className="sm:col-span-2">
            <label
              htmlFor="email"
              className="block text-sm font-semibold leading-6 text-gray-900"
            >
              Email
            </label>
            <div className="mt-2.5">
              <input
                type="email"
                name="from_name"
                id="from_name"
                placeholder="exemple@email.com"
                autoComplete="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="file-input file-input-bordered w-full px-2"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label
              htmlFor="first_name"
              className="block text-sm font-semibold leading-6 text-gray-900"
            >
              Contact
            </label>
            <div className="relative flex w-full ">
              <Menu placement="bottom-start">
                <MenuHandler>
                  <Button
                    ripple={false}
                    variant="text"
                    color="blue-gray"
                    className="flex h-12 items-center gap-2 rounded-r-none  border-0  bg-gray-300 pl-3"
                  >
                    <img
                      src={flags.svg}
                      alt={name}
                      className="h-4 w-4 rounded-full object-cover"
                    />
                    {countryCallingCode}
                  </Button>
                </MenuHandler>
                <MenuList className="max-h-[20rem] max-w-[18rem]">
                  {countries.map(({ name, flags, countryCallingCode }, index) => {
                    return (
                      <MenuItem
                        key={name}
                        value={name}
                        className="flex items-center gap-2"
                        onClick={() => setCountry(index)}
                      >
                        <img
                          src={flags.svg}
                          alt={name}
                          className="h-5 w-5 rounded-full object-cover"
                        />
                        {name} <span className="ml-auto">{countryCallingCode}</span>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Menu>
              <input
                type="tel"
                name='contact'
                id='contact'
                placeholder="01 23 45 67 89"
                value={formData.contact}
                onChange={(e) =>
                  setFormData({ ...formData, contact: e.target.value })
                }
                className="file-input file-input-bordered w-full rounded-l-none px-2"

              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label
              htmlFor="message"
              className="block text-sm font-semibold leading-6 text-gray-900"
            >
              Message
            </label>
            <div className="mt-2.5">
              <textarea
                name="message"
                id="message"
                placeholder="Décrirez votre message ici (minimum 10 caractères)..."
                rows={5}
                className="textarea textarea-bordered w-full "
                value={formData.message}
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
              />
            </div>
          </div>
          <div className="sm:col-span-2 text-gray-600">

            <ul><li>Nous respectons votre vie privée. Vos coordonnées ne seront ni publiées, ni utilisées à des ﬁns personnelles.</li></ul>
          </div>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            className="block w-full rounded-md bg-black px-3.5 py-4 text-center text-sm font-semibold text-white shadow-none hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Envoyer
          </button>
        </div>
      </form>
    </div>
  );
}

export default Contact;
